/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/cookie'
export default icon
